// @ts-nocheck
import React, { useState } from 'react';
import { useCompanyContext } from '../context/CompanyContext';
import { WorkflowStepBody } from '../components/WorkflowStepBody';
import { Analysis } from '../workflow/CompanyApp';
import { useNavigateWorkflowStep } from './workflowStepNav';
import { useCalculateRun } from '../hooks/useCalculateRun';

export default function AnalysisResultsPage() {
  const {
    data,
    currentAnalysisId,
    navigateTo,
    parachuteSubTab,
    setParachuteSubTab,
    parachuteEquitySubTab,
    setParachuteEquitySubTab,
    documentsSubTab,
    setDocumentsSubTab,
    currentAnalysis,
    setAnalyses,
    isCurrentAnalysisLocked,
  } = useCompanyContext();
  const [parachuteExpanded, setParachuteExpanded] = useState(true);
  const [documentsExpanded, setDocumentsExpanded] = useState(false);
  const setSelectedStepId = useNavigateWorkflowStep(navigateTo);

  const { isCalculating, calculateNotice, lastRunLabel, isRunStale, handleCalculate } = useCalculateRun({
    formData: data,
    currentAnalysisId,
    currentAnalysis,
    setAnalyses,
    isCurrentAnalysisLocked,
  });

  return (
    <WorkflowStepBody
      formData={data}
      selectedStepId="analysis"
      setSelectedStepId={setSelectedStepId}
      parachuteSubId={parachuteSubTab}
      setParachuteSubId={setParachuteSubTab}
      parachuteEquitySubId={parachuteEquitySubTab}
      setParachuteEquitySubId={setParachuteEquitySubTab}
      parachuteExpanded={parachuteExpanded}
      setParachuteExpanded={setParachuteExpanded}
      documentsSubId={documentsSubTab}
      setDocumentsSubId={setDocumentsSubTab}
      documentsExpanded={documentsExpanded}
      setDocumentsExpanded={setDocumentsExpanded}
    >
      <div className="space-y-3">
        <Analysis
          formData={data}
          onCalculate={handleCalculate}
          isCalculating={isCalculating}
          calculateNotice={calculateNotice}
          lastRunLabel={lastRunLabel}
          isRunStale={isRunStale}
          analysisLocked={isCurrentAnalysisLocked}
        />
      </div>
    </WorkflowStepBody>
  );
}
